jQuery(document).ready(function($){

    $('[data-search]').click(function() {
        $('.header__search').slideToggle('fast');
    });

});
